import { createSelector } from '@reduxjs/toolkit';

import { recentUnitsSel } from '@shared/duck/selectors/general.selectors';
import { applySort } from '@utils';

import { moduleName } from '../constants';
import {
  councilUnitsSorters,
  recentUnitsSorters,
} from '../councilUnitsSorters';

const moduleSel = state => state[moduleName];
const unitModuleSel = state => state['unit'];
export const activeTabSel = state => moduleSel(state).activeTab;
export const searchLoadingSel = state => moduleSel(state).searchLoading;
export const unitsSel = state => moduleSel(state).units;
export const searchSel = state => moduleSel(state).search;
export const recentUnitsSearchSel = state => moduleSel(state).recentUnitsSearch;
export const sorterSel = state => moduleSel(state).sorter;
export const recentUnitsSorterSel = state => moduleSel(state).recentUnitsSorter;

const makeSearch = rawQuery => {
  const query = `${rawQuery || ''}`.toLowerCase();
  return rawValue => {
    const value = `${rawValue || ''}`.toLowerCase();
    return value.includes(query);
  };
};

export const filteredUnitsSel = createSelector(
  unitsSel,
  searchSel,
  sorterSel,
  (units, search, sorter) => {
    const searchIncludes = makeSearch(search);
    const filteredItems = units.filter(({ charteredOrganizationName }) =>
      searchIncludes(charteredOrganizationName),
    );

    return applySort({
      sorter,
      items: filteredItems,
      sorters: councilUnitsSorters,
    });
  },
);
export const isVisibleMBRModalSel = state => moduleSel(state).isVisibleMBRModal;

export const modalVisibleSel = state => moduleSel(state).modalVisible;
export const uploadingSel = state => moduleSel(state).uploading;
export const uploadProgressSel = state => moduleSel(state).uploadProgress;
export const uploadedFilesSel = state => moduleSel(state).uploadedFiles;
export const uploadErrorSel = state => moduleSel(state).uploadError;
export const uploadErrorDescSel = state => moduleSel(state).uploadErrorDesc;
export const errorsModalVisibleSel = state =>
  moduleSel(state).errorsModalVisible;
export const cancellingSel = state => moduleSel(state).cancelling;

export const selectedUnitSel = state => moduleSel(state).selectedUnit;
export const districtsLoadingSel = state => moduleSel(state).districtsLoading;
export const districtsSel = state => moduleSel(state).districts;

export const currentCouncilUnitInfoSel = state => unitModuleSel(state).unitInfo;

/**
 * Returns if council user is using a unit that he doesn't belong to
 */
export const isCouncilUsingUnitSel = createSelector(
  selectedUnitSel,
  currentCouncilUnitInfoSel,
  (councilSelectedUnit, currentUnitInfo) =>
    councilSelectedUnit?.organizationGuid === currentUnitInfo?.organizationGuid,
);

export const filteredRecentUnitsSel = createSelector(
  recentUnitsSel,
  recentUnitsSearchSel,
  recentUnitsSorterSel,
  (recentUnits, search, sorter) => {
    const searchIncludes = makeSearch(search);
    const filteredItems = recentUnits.filter(
      unit =>
        searchIncludes(unit.charteredOrganizationName) ||
        searchIncludes(unit.districtName) ||
        searchIncludes(unit.unitNumber) ||
        searchIncludes(unit.unitType),
    );
    return applySort({
      sorter,
      items: filteredItems,
      sorters: recentUnitsSorters,
    });
  },
);
